import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import TableAdvertising from 'views/machine/cashier/tableAdvertising'; // Importing TableAdvertising component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * AdvertisingView class extends JetView to create a view for advertising management.
 */
export default class AdvertisingView extends JetView {
    /**
     * Configures the UI components of the AdvertisingView.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        // Toolbar configuration with pagination controls
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager',
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from config
                },
            ],
        };

        // Left panel configuration containing an accordion and advertising table
        const left = {
            responsiveCell: false,
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion view for collapsible sections
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            label: _('Publicidad Máquina'), // Section label
                            header: _('Publicidad Máquina'), // Header for the accordion
                            body: {
                                rows: [
                                    {
                                        padding: 5,
                                        height: 50,
                                        cols: [
                                            { gravity: 6, minWidth: 170 }, // Column configuration
                                            {
                                                view: 'button',
                                                value: _('Añadir Publicidad'), // Button label
                                                type: 'form',
                                                click: () => {
                                                    // Click event handler for the button
                                                    this.app.callEvent(
                                                        'addAdvertising:button', // Event name
                                                        [[]], // Event parameters
                                                    );
                                                },
                                            },
                                        ],
                                    },
                                    TableAdvertising, // Including the TableAdvertising component
                                    toolbar, // Including the toolbar
                                ],
                            },
                        },
                    ],
                },
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            type: 'wide', // View type
            responsive: true, // Enable responsive layout
            cols: [left], // Main layout columns
        };
    }
}

// FILE DOCUMENTED
